import { IDropDownOptions } from "../Component/Common/Components/FormValidationInputs/AppSelectList";

export function objectToDropdownOptions(x: { id: number; name: string }[]): IDropDownOptions[] {
    return Object.entries(x).map(([id, name]: [string, any]) => ({
        id: Number(id),
        value: name as string
    }));
};